import { connect } from 'react-redux'
import OrdersEditView from './OrdersEditView.jsx'


class OrdersCompleteView extends OrdersEditView {
  constructor(props, context) {
    const localProps = {
      ...props,
      initialState: {
        status: 'completed'
      }
    }

    super(localProps, context)
  }
}

const mapStateToProps = (state) => {
  return {
    page: 'complete',
    order: state.orders.current.order,
    currentUser: state.currentUser.user,
    skus: state.skus.all || [],
    serverErrors: state.errors.orders.create || {}
  }
}

const connectedOrdersCompleteView = connect(mapStateToProps,)(OrdersCompleteView)
export default connectedOrdersCompleteView